import { ResourceDimensionType } from "src/organization/pages/project/environment/metrics/types";

const isEnterpriseSplit = (dimensions: Array<ResourceDimensionType> | null) => {
  const hostTypes = Array.from(
    new Set(
      dimensions
        ?.map(dimension => dimension?.hostType)
        .filter(hostType => !!hostType)
    )
  );
  return hostTypes.length > 1;
};

export default isEnterpriseSplit;
